var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.4 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.9,13.3c-1.4-5.2-5.5-9.3-10.7-10.7C98.7,0,60.7,0,60.7,0c0,0-38,0-47.5,2.5C8.1,3.9,3.9,8.1,2.5,13.3,0,22.8,0,42.5,0,42.5c0,0,0,19.8,2.5,29.2,1.4,5.2,5.5,9.3,10.7,10.7,9.6,2.6,47.5,2.6,47.5,2.6,0,0,38,0,47.5-2.5,5.2-1.4,9.3-5.5,10.7-10.7,2.5-9.5,2.5-29.2,2.5-29.2,0,0,.1-19.8-2.5-29.3h0ZM48.6,60.7V24.3l31.6,18.2-31.6,18.2Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.b829d7d8720f1fbe26bd3628c8f67076.svg";
export { ForwardRef as ReactComponent };